import { isURL } from '@/assets/js/validate.js'
export default {
  methods: {
    audioUrlsFun(data) {
      if (data.audioFiles) {
        for (let s = 0; s < data.audioFiles.length; s++) {
          //   console.log(data.audioFiles[s]);
          this.audioUrls.push({
            text: '全程',
            // name: `${data.surveyTitle}音频${s + 1}${data.id}`,
            name: `音频${s + 1}${data.id}`,
            imgArr: this._getDownloadUrl(data.audioFiles[s]),
            dltext: this._getDownloadUrl(data.audioFiles[s], 'isAudio', `${data.surveyTitle}音频${s + 1}${data.id}`), // isAudio 20200616 hack 音频用新的接口
            rate: 1.0 //播放速度
          })
        }
        // console.log(this.audioUrls);
      }
    },
    videoUrlsFun(data) {
      if (data.videoFiles) {
        for (let s = 0; s < data.videoFiles.length; s++) {
          this.videoUrls.push({
            text: '全程',
            name: `${data.surveyTitle}视频${s + 1}${data.id}`,
            // imgArr: window.location.origin + data.videoFiles[s]
            imgArr: this._getDownloadUrl(data.videoFiles[s])
          })
        }
      }
    },
    // 全局图片
    picGlobalFun(data) {
      if (Array.isArray(data.imageFiles)) {
        for (let s = 0; s < data.imageFiles.length; s++) {
          this.imageGlobalUrls.push({
            text: '全程',
            id: data.id,
            mediaUrl: data.imageFiles[s],
            name: data.surveyTitle + '图片' + data.id,
            imgArr: this._getDownloadUrl(data.imageFiles[s])
          })
        }
      }
    },
    // 问卷图片
    picSurveyFun(data) {
      var a = []
      if (data.answerContent) {
        for (let index = 0; index < data.answerContent.length; index++) {
          let tempData = data.answerContent[index]
          if (tempData.photoFiles && tempData.photoFiles.length > 0) {
            var v = []
            for (let i = 0; i < tempData.photoFiles.length; i++) {
              v.push(this._getDownloadUrl(tempData.photoFiles[i]))
            }
            a.push({
              id: data.id,
              text: '问题' + (index + 1) + '：' + tempData.questionDetails.content.text,
              name: data.surveyTitle + '图片' + data.id,
              imgArr: v
            })
          }
        }
      }
      this.imageSurveyUrlArr = a
    },
    signFun(data) {
      var a = []
      if (data.answerContent) {
        for (let index = 0; index < data.answerContent.length; index++) {
          let tempData = data.answerContent[index]
          if (tempData.questionType === 14) {
            var v = []
            if (tempData.items) {
              // 兼容非必答题
              for (let i = 0; i < tempData.items.length; i++) {
                if (tempData.items[i].value) {
                  if (tempData.items[i].value.indexOf('=') != -1) {
                    v.push(this._getDownloadUrl(tempData.items[i].value.split('=')[1]))
                  } else {
                    v.push(this._getDownloadUrl(tempData.items[i].value))
                  }
                } else {
                  v.push('')
                }
              }
            }
            a.push({
              name:
                '问题' +
                (index + 1) +
                '：' +
                (tempData.questionDetails.content.richText || tempData.questionDetails.content.text),
              image: tempData.questionDetails.content.image,
              url: tempData.activePhotoFiles,
              imgArr: v
            })
          }
        }
      }
      this.signUrlArr = a
    },

    _getDownloadUrl(downUrl = '', flag, fileName) {
      let url = window.location.origin
      if (downUrl.includes('admin/sys-file')) {
        url = url + downUrl
      } else if (flag === 'isAudio') {
        url = url + '/fill/api/v1/downloadWithName?fileName=' + downUrl + '&downLoadName=' + fileName
      } else {
        // 如果是 http(s) 开头
        if (isURL(downUrl)) {
          url = downUrl
        } else {
          if (downUrl.startsWith('/')) {
            downUrl = downUrl.slice(1)
          }
          url = url + '/fill/api/v1/download?fileName=' + downUrl
        }
      }
      return url
    },
    returnFloat(data) {
      if (data == null) {
        return 0
      } else {
        let value = Math.round(parseFloat(data) * 100) / 100
        let s = value.toString().split('.')
        if (s.length == 1) {
          value = value.toString() + '.00'
          return value
        }
        if (s.length > 1) {
          if (s[1].length < 2) {
            value = value.toString() + '0'
          }
          return value
        }
      }
    },
    getImgArr(arg) {
      const answerArr = []
      if (!Array.isArray(arg)) {
        let url = this.row.questionDetails.issue.items.find(it => it.id == arg).content.image[0].url
        return window.location.origin + '/fill/api/v1/download?fileName=' + url
      }
      let answerVal = []
      this.row.items.forEach(item => {
        item.optionId && answerVal.push(item.optionId)
      })
      arg.forEach(element => {
        if (element.content.image && answerVal.includes(element.id)) {
          answerArr.push(window.location.origin + '/fill/api/v1/download?fileName=' + element.content.image[0].url)
        }
      })
      return answerArr
    }
  }
}
